export const iconFontAwesomeMarketingAnchorLock = (
	<i className="fa-solid fa-anchor-lock"></i>
);
